import React from 'react';
import { View, Modal } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import CustomButton, { ButtonTypes } from '../../../components/CustomButton';
import { translate } from '../../../services/translate';
import MyAppText from '../../../components/MyAppText';


interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onSubmit: () => void;
    onCancel?: () => void;
    itemName?: string;
    customMessage?: string;
    customConfirm?: string;
    onSubmitType?: ButtonTypes;
    isLoading?: boolean;
}

export default function UnblockModal({
    isModalVisible,
    setModalVisible,
    onSubmit,
    onCancel,
    itemName,
    customMessage,
    customConfirm,
    onSubmitType,
    isLoading,
}: ModalProps) {
    const { styles } = useStyles(styleSheet);

    if (!onSubmitType) {
        onSubmitType = 'primary';
    }

    return (
        <Modal
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => {
                onCancel && onCancel();
                setModalVisible(false);
            }}
            transparent={true}
        >
            <View style={styles.container}>
                <View style={styles.body}>
                    <MyAppText style={styles.unblockConfirmationText}>{customMessage ?? (itemName ? `${translate('confirm_unblock')}: ${itemName}` : `${translate('confirm_unblock')}?`)}</MyAppText>
                    <View style={styles.unblockButtonsView}>
                        <CustomButton
                            onPress={() => {
                                onCancel && onCancel();
                                setModalVisible(false);
                            }}
                            text={translate('cancel')}
                            type='secondary' />
                        <CustomButton
                            onPress={() => {
                                onSubmit();
                                setModalVisible(false);
                            }}
                            isLoading={isLoading}
                            type={onSubmitType}
                            text={customConfirm ?? translate('unblockUser')} />
                    </View>
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    body: {
        backgroundColor: theme.colors.card.background,
        flexDirection: 'column',
        borderRadius: 4,
        padding: 25,
        rowGap: 20,
    },
    headerText: {
        fontSize: 20,
    },
    buttonsView: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        gap: 20
    },
    unblockConfirmationText: {
        fontSize: 20,
    },
    unblockButtonsView: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    }
}));
